import { styled } from '@mui/system';
import { Skeleton } from '@mui/material';

const RootDiv = styled('div')({
  width: '100%',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  padding: '12px',
  borderBottom: '1px solid #EAEAEA',
  alignItems: 'center',
  height: '104.5px',
  position: 'relative',
  ':last-child': {
    borderRadius: '0 0 10px 10px',
    borderBottom: 'none',
  },
});

const ProductQuantity = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '0 20px',
});

const VerticalLine = styled('hr')({
  height: '104.5px',
  margin: 0,
  border: '1px solid #EAEAEA',
  position: 'absolute',
  marginLeft: '60px',
});

const ImgDiv = styled('div')({
  display: 'flex',
  width: '80px',
  justifyContent: 'center',
  marginLeft: '30px',
  height: 'inherit',
  alignItems: 'center',
});

const ImgProduct = styled('img')({
  width: '100%',
  display: 'block',
  objectFit: 'contain',
  maxHeight: '80%',
});

const SkeletonQuantity = styled(Skeleton)({
  width: '20px',
  height: '20px',
  marginLeft: '10px',
  marginRight: '50px',
});

const SkeletonImg = styled(Skeleton)({
  width: '5rem',
  height: '5rem',
});

const SkeletonText = styled(Skeleton)({
  width: '130px',
  height: '80px',
  marginLeft: '16px',
});

export {
  RootDiv,
  ProductQuantity,
  VerticalLine,
  ImgDiv,
  ImgProduct,
  SkeletonQuantity,
  SkeletonImg,
  SkeletonText,
};
